import { TM_COMMON_CONSTANTS } from '../pages/constants/tmCommonConstants';
import { TmCommonModules } from './apiModules/TmCommonModules';

export class NetworkLayer {
  constructor() {
    const { BASE_URL, HTTP_HEADERS, PREVENTION_COMMON } = TM_COMMON_CONSTANTS;
    this.tmCommonModules = new TmCommonModules(
      BASE_URL,
      HTTP_HEADERS,
      PREVENTION_COMMON
    );
  }

  tmCommonTransactionHistoryAPI = async (payload) =>
    await this.tmCommonModules.fetchTMCommonTransactionHistoryAPI(payload);

  tmCommonDownloadTransactionHistoryAPI = async (payload) =>
    await this.tmCommonModules.downloadTMCommonTransactionHistoryAPI(payload);

  // FIN-11360 — FRAML View queue CSV download.
  framlQueueExportAPI = async (payload) =>
    await this.tmCommonModules.downloadFramlQueueExportAPI(payload);

  tmCommonTransactionTriggeredTypologiesAPI = async (payload) =>
    await this.tmCommonModules.fetchTMCommonTransactionTriggeredTypologiesAPI(
      payload
    );

  tmCommonScoreExplainabilityAPI = async (payload) =>
    await this.tmCommonModules.fetchTMCommonScoreExplainablity(payload);

  preventionCommonScoreExplainabilityAPI = async (payload) =>
    await this.tmCommonModules.fetchPreventionCommonScoreExplainablity(payload);

  framlAlertEventsAPI = async (payload) =>
    await this.tmCommonModules.fetchFramlAlertEvents(payload);

  framlAlertScenariosAPI = async (payload) =>
    await this.tmCommonModules.fetchFramlAlertScenarios(payload);

  framlRelatedCasesAPI = async (payload) =>
    await this.tmCommonModules.fetchFramlRelatedCases(payload);

  alertScoreExplanationAPI = async (payload) =>
    await this.tmCommonModules.fetchAlertScoreExplanation(payload);

  tmCommonPeerAndProfileGraphAPI = async (payload) =>
    await this.tmCommonModules.fetchTMCommonPeerAndProfileGraph(payload);

  tmCommonTypologyListAPI = async (payload) =>
    await this.tmCommonModules.fetchTypologyList(payload);

  tmCommonVariantsListForAlertIdAPI = async (payload) =>
    await this.tmCommonModules.fetchVariantsListForAlertId(payload);

  tmCommonRiskIndicatorListAPI = async (payload) =>
    await this.tmCommonModules.fetchRiskIndicatorList(payload);

  amlsTMCommonCustomerLoanDetailsAPI = async (payload) =>
    await this.tmCommonModules.fetchTMCommonCustomerLoanDetails(payload);

  tmCommonTransactionTypesFilterAPI = async (payload) =>
    await this.tmCommonModules.fetchTransactionTypesFilterAPI(payload);

  amlsTMCommonActivityInformationAPI = async (payload) =>
    await this.tmCommonModules.fetchTMCommonActivityInformation(payload);

  amlsTMCommonDownloadActivityInformationAPI = async (payload) =>
    await this.tmCommonModules.downloadTMCommonActivityInformation(payload);

  // FIN-11542 — Activity tab Advanced Filter option lists (activityTypes,
  // activityStatuses, channels). Returns the BE-served lists; FE no longer
  // hardcodes ACTIVITY_FILTER_FIELDS.
  // FIN-12168 — forward the optional alert scope (alertId/customerId/from/to)
  // so the BE can return the DISTINCT facet values present in the alert.
  amlsTMCommonActivityFilterOptionsAPI = async (payload = {}) =>
    await this.tmCommonModules.fetchActivityFilterOptionsAPI(payload);
}
